<template>
    <span class="io-icon">
        <i :class="icon"></i>
    </span>
</template>

<script>
export default {
  name: 'IoIcon',
  props: {
    icon: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
.io-icon {
    color: currentColor
}
</style>
